import type { FunctionComponent } from "react";
import { useMemo } from "react";

import { useAggregatedDataV2 } from "~/hooks/useAggregatedDataV2.ts";
import { useProjectsInvoices } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import { useProjectsOrders } from "~/modules/project/api/order/orderQueries.ts";
import { useProjectsProjectPhases } from "~/modules/project/api/projectPhase/projectPhaseQueries.ts";
import ProjectsInvoicesTable
	from "~/modules/project/components/ProjectDetailsView/components/ProjectInvoicesTabContent/components/ProjectsInvoicesTable";
import type {
	ProjectsInvoicesTableData,
} from "~/modules/project/components/ProjectDetailsView/components/ProjectInvoicesTabContent/components/ProjectsInvoicesTable/projectsInvoicesTableTypes.ts";
import { getFullPhaseTitle } from "~/modules/project/utils/projectPhaseUtils.ts";

type Props = { projectId: string; };

const ProjectInvoicesTabContent: FunctionComponent<Props> = ({ projectId }) => {
	const { data, options } = useAggregatedDataV2({
		invoices: useProjectsInvoices(projectId),
		orders: useProjectsOrders(projectId),
		phases: useProjectsProjectPhases(projectId),
	});

	const { invoices, orders, phases } = data;
	const { isLoading } = options;

	const tableData: ProjectsInvoicesTableData[] = useMemo(() => {
		if (invoices !== undefined && orders !== undefined && phases !== undefined) {
			return invoices.map((invoice) => {
				let orderTitle = "diverse";
				let phaseTitle = "diverse";
				if(invoice.orders.length === 1){
					orderTitle = orders.find((order) => order.id === invoice.orders[0].id)?.title || "";
				}

				if (invoice.projectPhases.length === 1) {
					const phase = phases.find((phase) => phase.id === invoice.projectPhases[0].id);
					phaseTitle = phase ? getFullPhaseTitle(phase) : "diverse";
				}

				return {
					currencySymbol: invoice.currencySymbol,
					deliveryEndDate: new Date(invoice.deliveryEndDate),
					deliveryStartDate: new Date(invoice.deliveryStartDate),
					id: invoice.id,
					invoiceNumber: invoice.invoiceNumber,
					invoiceStatusId: invoice.invoiceStatusId,
					orderIds: invoice.orders.map((order) => order.id),
					orderTitle,
					phaseIds:invoice.projectPhases.map((phase) => phase.id),
					phaseTitle,
					totalAmountCents: invoice.totalAmountCents,
				};
			});

		}
		return [];
	}, [invoices, orders, phases]);

	return <ProjectsInvoicesTable isLoading={isLoading}
								  projectId={projectId}
								  projectPhases={phases}
								  tableData={tableData} />;
};

export default ProjectInvoicesTabContent;